// extracted by mini-css-extract-plugin
module.exports = {"modal__form":"styles_modal__form__1dSnp","modal__inner":"styles_modal__inner__3zCJq","modal__button":"styles_modal__button__2BU1k"};